<template>
  <transition
    name="bg-modal"
    @after-enter="portalOverlay"
    @after-leave="releaseScrollLock"
  >
    <div
      v-if="visible"
      ref="overlay"
      class="bg-modal-overlay"
      role="presentation"
      @click.self="close"
    >
      <div
        class="bg-withdraw-available-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bg-withdraw-available-modal-title"
        @keydown.esc.prevent="close"
      >
        <header class="bg-withdraw-available-modal__header">
          <h2 id="bg-withdraw-available-modal-title" class="bg-withdraw-available-modal__title">
            {{ $t('wallet.availableModalTitle') }}
          </h2>
          <button
            type="button"
            class="bg-withdraw-available-modal__close"
            :aria-label="$t('common.close')"
            @click="close"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </header>

        <div class="bg-withdraw-available-modal__summary">
          <span class="bg-withdraw-available-modal__summary-label">{{ $t('wallet.availableModalLabel') }}</span>
          <strong class="bg-withdraw-available-modal__summary-value">{{ availableAmount }}</strong>
        </div>

        <div class="bg-withdraw-available-modal__body">
          <slot />
        </div>

        <footer class="bg-withdraw-available-modal__footer">
          <button
            type="button"
            class="bg-withdraw-available-modal__refresh"
            :disabled="balanceLoading"
            @click="$emit('refresh')"
          >
            {{ balanceLoading ? $t('common.loading') : $t('wallet.refreshBalance') }}
          </button>
          <button
            type="button"
            class="bg-withdraw-available-modal__confirm"
            @click="close"
          >
            {{ $t('common.confirm') }}
          </button>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { clearBgModalScrollLock } from '@/utils/scrollLock'

export default {
  name: 'BlackGoldWithdrawAvailableModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    availableAmount: {
      type: String,
      default: '-'
    },
    balanceLoading: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (open) {
        if (open) {
          this.$nextTick(this.portalOverlay)
        } else {
          this.releaseScrollLock()
        }
      }
    }
  },
  beforeDestroy () {
    this.releaseScrollLock()
  },
  methods: {
    portalOverlay () {
      const el = this.$refs.overlay
      if (!el) return
      if (el.parentNode !== document.body) {
        document.body.appendChild(el)
      }
    },
    releaseScrollLock () {
      clearBgModalScrollLock()
    },
    close () {
      this.$emit('close')
      this.$nextTick(this.releaseScrollLock)
    }
  }
}
</script>
